import { Column, Radio, RadioGroup, Typography } from '@tempmee/react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showConfirmReportIncidentPopup } from '~/actions';
import { ConfirmPopupContent } from '~/components/shared/ConfirmPopupContent';

import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { NumberUtils } from '~/utils/NumberUtils';
import { incidentTypes } from '../utils/incidentPopupUtil';

export const ConfirmationSelectIncident = ({ onClose }) => {
  const dispatch = useDispatch();
  const [incidentType, setIncidentType] = useState(null);

  return (
    <ConfirmPopupContent
      Icon={() => <OutlineWarning01Icon color={colors.warning[500]} size={60} />}
      title="Report An Incident"
      // Fix momentary misalignment of the title with the icon due to the icon's vertical alignment.
      titleStyle={{
        marginTop: 12,
      }}
      description={
        // gap replaces the radio row's compensating marginTop/Bottom for even rhythm.
        <Column gap={5} data-cy="select-incident-type-content">
          <Typography as="span" textAlign="center" data-cy="incident-prompt-text">
            What type of incident would you like to report?
          </Typography>
          <RadioGroup
            value={incidentType ?? ''}
            onChange={setIncidentType}
            orientation="horizontal"
            data-cy="incident-type-options"
            style={{ justifyContent: 'space-around' }}
          >
            <Radio value={incidentTypes.noShow} label="No-Show" data-cy="incident-type-no-show" />
            <Radio
              value={incidentTypes.walkedOut}
              label="Walked-Out"
              data-cy="incident-type-walked-out"
            />
          </RadioGroup>
          <Typography as="span" textAlign="center" data-cy="incident-support-text">
            If the incident doesn&apos;t fall into these two categories, please call or text our
            Customer Support at {NumberUtils.getCSPhone().formattedSimplified}, and they will be
            able to assist you.
          </Typography>
        </Column>
      }
      leftButtonAction={onClose}
      leftButtonText="Go Back"
      leftButtonDataCy="incident-go-back-button"
      rightButtonAction={() => {
        dispatch(showConfirmReportIncidentPopup({ incidentType }));
      }}
      rightButtonDisabled={!incidentType}
      rightButtonText="Continue"
      rightButtonDataCy="incident-continue-button"
    />
  );
};
